import {
  SUBSCRIPTION_PRICING,
  SUBSCRIPTION_TIER,
} from "@highnote/server/src/core/entities";

export type PlanConfig = {
  name: string;
  tier: SUBSCRIPTION_TIER;
  prices: string[];
  features: string[];
};

export const PLANS: PlanConfig[] = [
  {
    name: "Free",
    tier: SUBSCRIPTION_TIER.FREE,
    prices: [],
    features: [
      "15 total tracks",
      "50GB cloud storage",
      "Unlimited sharing",
      "Time-stamped commenting",
    ],
  },
  {
    name: "Indie",
    tier: SUBSCRIPTION_TIER.INDIE,
    prices: Object.values(SUBSCRIPTION_PRICING[SUBSCRIPTION_TIER.INDIE]),
    features: [
      "500 total tracks",
      "1TB cloud storage",
      "Download prevention",
      "Password protected links",
      "Stream lossless audio",
      "Manage unlimited track versions",
    ],
  },
  {
    name: "Studio",
    tier: SUBSCRIPTION_TIER.STUDIO,
    prices: Object.values(SUBSCRIPTION_PRICING[SUBSCRIPTION_TIER.STUDIO]),
    features: [
      "Unlimited tracks",
      "5TB cloud storage",
      "Share lossless audio",
      "Default audio quality",
    ],
  },
];
